import { MessageBarType } from '@fluentui/react'
import { createReducer } from 'typesafe-actions'
import {
  IChifamDetailsRes,
  IChifamHoldingDetail,
  IHoldings,
  IChifamAccountsRes
} from '../api/types'
import {
  ChifamActionsTypes,
  fetchChifamDetailsActions,
  fetchChifamHoldingDetailsActions,
  fetchChifamHoldingSummaryActions,
  fetchAccountsActions,
  insertUpdateReallocationActions,
  generateDocumentActions,
  fetchChifamAccountsActions
} from './actions'

export interface IChifamState {
  getChifamDetailsState?: {
    inProgress: boolean
    errorCode?: string
    msg?: string
    messageType?: MessageBarType
    data?: IChifamDetailsRes
  }
  getChifamHoldingsState?: {
    inProgress: boolean
    errorCode?: string
    msg?: string
    messageType?: MessageBarType
    data?: IHoldings
  }
  getChifamHoldingSummaryState?: {
    inProgress: boolean
    errorCode?: string
    msg?: string
    messageType?: MessageBarType
    data?: IChifamHoldingDetail[]
  }
  getAccountsState?: {
    inProgress: boolean
    errorCode?: string
    msg?: string
    messageType?: MessageBarType
    data?: any
  }
  insertUpdateReallocationState?: {
    inProgress: boolean
    errorCode?: string
    msg?: string
    messageType?: MessageBarType
    data?: any
  }
  generateDocumentState?: {
    inProgress: boolean
    errorCode?: number
    msg?: string
    messageType?: MessageBarType
    data?: Blob
  }
  getChifamAccountsState?: {
    inProgress: boolean
    errorCode?: string
    msg?: string
    messageType?: MessageBarType
    data?: IChifamAccountsRes
  }
  isDetailedViewOpen?: boolean

  groupUsersState?: {
    users: any[]
  }
  activeTab?: string
}
const initialState: IChifamState = {
  isDetailedViewOpen: false,
  activeTab: 'ALL'
}

export const chifamReducer = createReducer<IChifamState, ChifamActionsTypes>(
  initialState
)
  .handleAction(fetchChifamDetailsActions.request, (state) => ({
    ...state,
    getChifamDetailsState: {
      inProgress: true,
      error: undefined,
      data: undefined
    }
  }))
  .handleAction(fetchChifamDetailsActions.success, (state, action) => {
    return {
      ...state,
      getChifamDetailsState: {
        inProgress: false,
        error: undefined,
        data: action.payload,
        messageType: MessageBarType.success
      }
    }
  })
  .handleAction(fetchChifamDetailsActions.failure, (state, action) => ({
    ...state,
    getChifamDetailsState: {
      inProgress: false,
      error: action.payload,
      data: undefined,
      messageType: MessageBarType.error
    }
  }))
  .handleAction(fetchChifamDetailsActions.clear, (state) => ({
    ...state,
    getChifamDetailsState: undefined
  }))
  .handleAction(fetchChifamHoldingDetailsActions.request, (state) => ({
    ...state,
    getChifamHoldingsState: {
      inProgress: true,
      error: undefined,
      data: undefined
    }
  }))
  .handleAction(fetchChifamHoldingDetailsActions.success, (state, action) => ({
    ...state,
    getChifamHoldingsState: {
      inProgress: false,
      error: undefined,
      data: action.payload,
      messageType: MessageBarType.success
    }
  }))
  .handleAction(fetchChifamHoldingDetailsActions.failure, (state, action) => ({
    ...state,
    getChifamHoldingsState: {
      inProgress: false,
      error: action.payload,
      data: undefined,
      messageType: MessageBarType.error
    }
  }))
  .handleAction(fetchChifamHoldingDetailsActions.clear, (state) => ({
    ...state,
    getChifamHoldingsState: undefined
  }))
  .handleAction(fetchChifamHoldingSummaryActions.request, (state) => ({
    ...state,
    getChifamHoldingSummaryState: {
      inProgress: true,
      error: undefined,
      data: undefined
    }
  }))
  .handleAction(fetchChifamHoldingSummaryActions.success, (state, action) => ({
    ...state,
    getChifamHoldingSummaryState: {
      inProgress: false,
      error: undefined,
      data: action.payload,
      messageType: MessageBarType.success
    }
  }))
  .handleAction(fetchChifamHoldingSummaryActions.failure, (state, action) => ({
    ...state,
    getChifamHoldingSummaryState: {
      inProgress: false,
      error: action.payload,
      data: undefined,
      messageType: MessageBarType.error
    }
  }))
  .handleAction(fetchChifamHoldingSummaryActions.clear, (state) => ({
    ...state,
    getChifamHoldingSummaryState: undefined
  }))
  .handleAction(fetchAccountsActions.request, (state) => ({
    ...state,
    getAccountsState: {
      inProgress: true,
      error: undefined,
      data: undefined
    }
  }))
  .handleAction(fetchAccountsActions.success, (state, action) => ({
    ...state,
    getAccountsState: {
      inProgress: false,
      error: undefined,
      data: action.payload,
      messageType: MessageBarType.success
    }
  }))
  .handleAction(fetchAccountsActions.failure, (state, action) => ({
    ...state,
    getAccountsState: {
      inProgress: false,
      error: action.payload,
      data: undefined,
      messageType: MessageBarType.error
    }
  }))
  .handleAction(fetchAccountsActions.clear, (state) => ({
    ...state,
    getAccountsState: undefined
  }))
  .handleAction(insertUpdateReallocationActions.request, (state) => ({
    ...state,
    insertUpdateReallocationState: {
      inProgress: true,
      error: undefined,
      data: undefined
    }
  }))
  .handleAction(insertUpdateReallocationActions.success, (state, action) => ({
    ...state,
    insertUpdateReallocationState: {
      inProgress: false,
      error: undefined,
      data: action.payload,
      messageType: MessageBarType.success
    }
  }))
  .handleAction(insertUpdateReallocationActions.failure, (state, action) => ({
    ...state,
    insertUpdateReallocationState: {
      inProgress: false,
      error: action.payload,
      data: undefined,
      messageType: MessageBarType.error
    }
  }))
  .handleAction(insertUpdateReallocationActions.clear, (state) => ({
    ...state,
    insertUpdateReallocationState: undefined
  }))
  .handleAction(generateDocumentActions.request, (state) => ({
    ...state,
    generateDocumentState: {
      inProgress: true,
      error: undefined,
      data: undefined
    }
  }))
  .handleAction(generateDocumentActions.success, (state, action) => ({
    ...state,
    generateDocumentState: {
      inProgress: false,
      error: undefined,
      data: action.payload,
      messageType: MessageBarType.success
    }
  }))
  .handleAction(generateDocumentActions.failure, (state, action) => ({
    ...state,
    generateDocumentState: {
      inProgress: false,
      error: action.payload,
      errorCode: (action.payload as any)?.errorCode,
      msg: action.payload?.message || 'Failed to generate document',
      data: undefined,
      messageType: MessageBarType.error
    }
  }))
  .handleAction(generateDocumentActions.clear, (state) => ({
    ...state,
    generateDocumentState: undefined
  }))
  .handleAction(fetchChifamAccountsActions.request, (state) => ({
    ...state,
    getChifamAccountsState: {
      inProgress: true,
      error: undefined,
      data: undefined
    }
  }))
  .handleAction(fetchChifamAccountsActions.success, (state, action) => ({
    ...state,
    getChifamAccountsState: {
      inProgress: false,
      error: undefined,
      data: action.payload,
      messageType: MessageBarType.success
    }
  }))
  .handleAction(fetchChifamAccountsActions.failure, (state, action) => ({
    ...state,
    getChifamAccountsState: {
      inProgress: false,
      error: action.payload,
      data: undefined,
      messageType: MessageBarType.error
    }
  }))
  .handleAction(fetchChifamAccountsActions.clear, (state) => ({
    ...state,
    getChifamAccountsState: undefined
  }))
